module.exports = __webpack_public_path__ + "static/media/8706.468b723c.png";